import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>Officer South – Ballarto Road Storage Tank </h3>
      </div>
      <div className="popup-content-source">
        <p className="bold">
        This project is to deliver a new storage tank as part of the Ballarto Road Sewer Rising Main and Pump Station Upgrade, which will increase the capacity of the pump station and meet the growing demands of the Clyde area.  
        </p>

        <p>
        We’ve awarded this part of the upgrade to our Industry partner Abergeldie, KBR, BMD Joint Venture (ABK). 
        We expect construction to begin early 2027 for approximately 15 months (dependant on weather).
        </p>
        <p>
          For more information visit{' '}
          <a
            href="https://southeastwater.com.au/faults-and-works/works/planned-works/ballartord/"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: `Map – Water Renewals (blue)`,
                action: '<a href> link',
                label: 'MORE INFO: Ballarto Road Pump Station Upgrade',
              });
            }}
          >
            Ballarto Road Pump Station Upgrade | South East Water
          </a>{' '}
          email{' '}
          <a
            href="mailto:engagement@sew.com.au"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: `Map - Water Renewals (blue)`,
                action: 'Email link',
                label:
                  'MAIL TO: engagement@sew.com.au: Ballarto Road Pump Station Upgrade',
              });
            }}
          >
            engagement@sew.com.au
          </a>{' '}
          or call <a href="tel:1800403777">1800 403 777</a> |{' '}
        </p>
      </div>
    </>
  );
};

export default Content;
